import axios from "axios";
import { FieldValue, FieldValueListing } from "../constants/Types";

const apiurl = process.env.REACT_APP_API_Base_Url;

export interface ForecastResult {
  index: number;
  forecastedQuantity: number;
  lowerBoundQuantity: number;
  upperBoundQuantity: number;
}

export const GetInventoryListing = async (): Promise<FieldValue[]> => {
  const response = await axios.get<FieldValueListing>(
    `${apiurl}Inventory/GetList`);
  return response.data.data;
};

export async function getForecast(itemId: string) {
  if (!itemId) return [];
  //const response = await fetch(`${apiurl}Forecast/ForcastedResultBy13Week?Item=${itemId}`);
//  const response = await fetch(`https://localhost:44319/api/Forecast/ForcastedResultBy13Week?Item=${itemId}`);
const response = await fetch(`${apiurl}Forecast/ClosingInventoryBy13Week?Item=${itemId}`);
  if (!response.ok) throw new Error('Failed to fetch forecast');
  return await response.json();
}

export async function addManualForecast(itemId: string,foreCastDate :string, quantity : number) {
  console.log(apiurl);
  if (!itemId) return [];
  interface ForecastPayload {
  id: number;
  itemId: string;
  foreCastDate: string;
  quantity: number;
  entryFrom:string;
}

interface ApiResponse {
  success: boolean;
  message: string;
  data?: any; // Replace `any` with expected response structure
}

   const payload: ForecastPayload = {
    id: 0,
    itemId,
    foreCastDate,
    quantity,
    entryFrom:"Inventory",
  };
   try {
    const response = await axios.post<ApiResponse>(`${apiurl}ManualForeCast/add`, payload);
    console.log(" API Response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("❌ Error posting data:", error);
    return {
      success: false,
      message: error.message || "An error occurred",
    };
  }
 //const response = await axios.post(`${apiurl}add`, {
 //  id:0,
 //  itemId:itemId,
 //  foreCastDate :foreCastDate,
 //  quantity:quantity
 //});
 //console.log("dattttttttta" ,response);
 //return response.data;
}

export const getCashForecast = async (futureDate: string) => {
  const response = await axios.get(`${apiurl}cashtransactionforecasting/weekly-forecast`, {
    params: { futureDate }
  });
  return response.data;
};

export const getShippingVolumeForecast = async (futureDate: string) => {
  const response = await axios.get(
    `${apiurl}DistributedForecasting/shipping-volume`,
    {
      params: { futureDate },
    }
  );
  return response.data.data; // Assumes the forecast is in response.data.data
};

export const getDeliveryTimeForecast = async () => {
  const response = await axios.get(`${apiurl}DistributedForecasting/delivery-time`);
  return response.data.data;
};

export const getReturnRateForecast = async () => {
  const response = await axios.get(`${apiurl}DistributedForecasting/return-rate`);
  return response.data.data;
};

export const getCostPerItemForecast = async () => {
  const response = await axios.get(`${apiurl}DistributedForecasting/cost-per-item`);
  return response.data.data;
};

export const getDynamicForecast = async (itemId: string, targetColumn: string, horizon: number) => {
  const res = await fetch(
    `${apiurl}AnalysisForecasting/predict?itemId=${itemId}&targetColumn=${targetColumn}&horizon=${horizon}`
  );
  return await res.json();
};

export const getTradingBalanceForecast = async (
  accountId: string,
  targetDateTime: string
): Promise<{ predictedBalance: number }> => {
  const response = await axios.get(`${apiurl}BalanceForecast/predictTrade`, {
    params: { accountId, targetDateTime },
  });
  return response.data;
};

export const getCurrentBalance = async (
  accountId: string
): Promise<{ balance: number }> => {
  const response = await axios.get(`${apiurl}BalanceForecast/currentBalance`, {
    params: { accountId },
  });
  return response.data;
};

export const getAccountList = async (): Promise<{
  data: { accountId: string; accountName: string }[];
}> => {
  const response = await axios.get(`${apiurl}BalanceForecast/AccountList`);
  return response.data;
};


export interface VolumeEntry {
  date: string;
  volume: number;
  type: "historical" | "forecasted";
}

export const getShippingVolumeForecastBySKU = async (
  sku: string,
  duration: string
): Promise<VolumeEntry[]> => {
  const response = await axios.get(`${apiurl}DistributedForecasting/shipping-volume-by-sku`, {
    params: {
      sku,
      duration,
    },
  });

  const data = response.data.data;

  // Transform the data into a unified list with type labels
  const historical: VolumeEntry[] = (data?.distributionRecords || []).map((item: any) => ({
    date: item.date,
    volume: item.quantity,
    type: "historical",
  }));

  const forecasted: VolumeEntry[] = (data?.shipingVolumeForecastedData || []).map((item: any) => ({
    date: item.date,
    volume: item.volume,
    type: "forecasted",
  }));

  return [...historical, ...forecasted];
};


export const getSkuList = async (): Promise<
  { skuItem: string; value: string }[]
> => {
  const response = await axios.get(
    `${apiurl}DistributedForecasting/sku-master-list`
  );
  return response.data.data;
};
